module.exports = __webpack_public_path__ + "static/watch@2x-6177d25555f7aa2cec26f31b9cf4519f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/apple-watch-prototyping/watch@2x.jpg
// module id = 326
// module chunks = 3528254163161 126761542922144 223471745239978